function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;


//////////////////
// WEBPACK FOOTER
// ./~/@jsluna/date-picker/~/@babel/runtime/helpers/extends.js
// module id = 28
// module chunks = 0